/**
 * Generated by `bun run generate:deployment-config` from the canonical OAuth
 * registry and integration catalog. Do not edit this file directly.
 */
export const SERVICE_ACCOUNT_PROVIDER_BY_OAUTH_SERVICE_ID = {
  airtable: 'airtable-service-account',
  asana: 'asana-service-account',
  attio: 'attio-service-account',
  box: 'box-service-account',
  calcom: 'calcom-service-account',
  clickup: 'clickup-service-account',
  confluence: 'atlassian-service-account',
  gmail: 'google-service-account',
  'google-bigquery': 'google-service-account',
  'google-calendar': 'google-service-account',
  'google-contacts': 'google-service-account',
  'google-docs': 'google-service-account',
  'google-drive': 'google-service-account',
  'google-forms': 'google-service-account',
  'google-groups': 'google-service-account',
  'google-meet': 'google-service-account',
  'google-sheets': 'google-service-account',
  'google-tasks': 'google-service-account',
  'google-vault': 'google-service-account',
  hubspot: 'hubspot-service-account',
  jira: 'atlassian-service-account',
  linear: 'linear-service-account',
  monday: 'monday-service-account',
  notion: 'notion-service-account',
  pipedrive: 'pipedrive-service-account',
  ramp: 'ramp-service-account',
  salesforce: 'salesforce-service-account',
  shopify: 'shopify-service-account',
  slack: 'slack-custom-bot',
  trello: 'trello-service-account',
  vanta: 'vanta-service-account',
  wealthbox: 'wealthbox-service-account',
  webflow: 'webflow-service-account',
  'zoho-desk': 'zoho-desk-service-account',
  zoom: 'zoom-service-account',
} as const

/** OAuth services whose users supply app credentials when connecting an account. */
export const CREDENTIAL_CONFIGURED_OAUTH_SERVICE_IDS = ['quickbooks'] as const
